export default __webpack_public_path__ + "static/media/4.9ba3ae8b.jpg";